import { render, staticRenderFns } from "./PopUp.vue?vue&type=template&id=173e7b76"
import script from "./PopUp.vue?vue&type=script&lang=js"
export * from "./PopUp.vue?vue&type=script&lang=js"
import style0 from "./PopUp.vue?vue&type=style&index=0&id=173e7b76&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports